export default "__VITE_ASSET__EoQOfioj__"